import { render, staticRenderFns } from "./couponSelect.vue?vue&type=template&id=63d71916&scoped=true&"
import script from "./couponSelect.vue?vue&type=script&lang=js&"
export * from "./couponSelect.vue?vue&type=script&lang=js&"
import style0 from "./couponSelect.vue?vue&type=style&index=0&id=63d71916&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d71916",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
